if (!customElements.get('pvb-product-viewer')) {
  customElements.define('pvb-product-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.surface = this.querySelector('.pvb-surface');
      this.dataset.state = 'closed';
      const options = { signal: this.events.signal };
      this.querySelector('.pvb-open').addEventListener('click', () => this.open(), options);
      this.querySelector('.pvb-close').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('.pvb-retry').addEventListener('click', () => this.load(), options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.teardown();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
    }

    open() {
      if (this.dialog.open) return;
      this.previousOverflow ??= document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.dataset.state = 'loading';
      this.load();
    }

    async load() {
      this.guide?.dispose();
      this.guide = null;
      this.viewer?.dispose();
      this.viewer = null;
      const generation = this.generation = (this.generation || 0) + 1;
      this.surface.replaceChildren();
      this.surface.setAttribute('aria-busy', 'true');
      this.querySelector('.pvb-loading').hidden = false;
      this.querySelector('.pvb-error').hidden = true;
      delete this.dataset.error;
      try {
        // Classic CDN scripts have no usable import base in the theme editor.
        const viewerUrl = new URL(this.dataset.viewerUrl, document.baseURI).href;
        const { BatViewer, applyPreset, createViewerGuide } = await import(viewerUrl);
        if (generation !== this.generation || !this.dialog.open) return;
        const viewer = this.viewer = new BatViewer(this.surface, {
          modelUrl: this.dataset.modelUrl,
          configUrl: this.dataset.configUrl,
          dracoDecoderPath: this.dataset.decoderUrl,
          keyboardScope: 'viewer'
        });
        await viewer.load();
        if (generation !== this.generation || !this.dialog.open) return;
        if (this.dataset.productAdapterUrl) {
          const adapterUrl = new URL(this.dataset.productAdapterUrl, document.baseURI).href;
          const { resizeOneHandTrainer } = await import(adapterUrl);
          if (generation !== this.generation || !this.dialog.open) return;
          resizeOneHandTrainer(viewer);
        }
        applyPreset(viewer);
        this.guide = createViewerGuide(this, viewer);
        this.surface.setAttribute('aria-busy', 'false');
        this.querySelector('.pvb-loading').hidden = true;
        this.dataset.state = 'ready';
      } catch (error) {
        if (generation !== this.generation || !this.dialog.open) return;
        this.guide?.dispose();
        this.guide = null;
        this.viewer?.dispose();
        this.viewer = null;
        this.surface.replaceChildren();
        this.surface.setAttribute('aria-busy', 'false');
        this.querySelector('.pvb-loading').hidden = true;
        this.querySelector('.pvb-error').hidden = false;
        this.dataset.state = 'error';
        this.dataset.error = error instanceof Error ? error.message : String(error);
        console.error('Pro Velocity 3D viewer:', error);
      }
    }

    teardown() {
      this.dataset.state = 'closed';
      this.generation = (this.generation || 0) + 1;
      this.guide?.dispose();
      this.guide = null;
      this.viewer?.dispose();
      this.viewer = null;
      this.surface?.replaceChildren();
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.dialog?.close();
      this.teardown();
      this.events = null;
    }
  });
}
